import {memo, useContext} from "react";
import {Pagination, Table} from "antd";
import _ from "lodash"
import ServiceAction from "./ServiceAction";
import {
	renderDate,
	numberFormat
} from "~/utils";
import {StatusLabel} from "~/components";
import {useDevice, useCan} from "~/hooks";
import ContractCustomerAction from "../../../Contract/components/Table/ContractCustomerAction";
import {AppContext} from "~/context/AppProvider";

function ServiceTable({items = [], pagination, onPaginationChange, onChangeFilter, setItemEdit, openModal, can, serviceUseAllow, serviceUseCancel}) {

	const {tableHeight} = useContext(AppContext);

	const {isMobile} = useDevice();

	const renderEmail = (extend) => {
		return (
			(extend?.id && extend?.emailSend !== 0) ? <StatusLabel small type="green">Đã gửi</StatusLabel> : <StatusLabel small type="red">Chưa gửi</StatusLabel>
		)
	}

	const renderZalo = (extend) => {
		return (
			(extend?.id && extend?.zaloSend !== 0) ? <StatusLabel small type="green">Đã gửi</StatusLabel> : <StatusLabel small type="red">Chưa gửi</StatusLabel>
		)
	}

	const renderCall = (supportId, supportTime) => {
		return (
			(supportId === 0)
			? <StatusLabel small type="red">Chưa gọi</StatusLabel>
			: <StatusLabel small type="green">Đã gọi lúc {renderDate(supportTime)}</StatusLabel>
		)
	}

	const renderSubdomain = (domains) => {
		return ((!_.isEmpty(domains)) && domains.map((domain) => {
			return <p key={domain}>{domain}</p>;
		}))
	}

	let columns = [
		{title: 'Khách hàng', dataIndex: 'customer', key: "customer", width: '300px', render: (_, item) => (
			<>
				<p><b>{item.domain}</b></p>
				{renderSubdomain(item?.subDomain)}
				{
					can.customer && <>
						<p><ContractCustomerAction item={item} openModal={openModal} setItemEdit={setItemEdit} onChangeFilter={onChangeFilter}/> {item.customer?.name}</p>
						{
							isMobile &&
							<>
								{item.user?.id && <p>{`${item.user?.firstname} ${item.user?.lastname}`}</p>}
								{item.userShare?.id && <p>{`${item.userShare?.firstname} ${item.userShare?.lastname}`}</p>}
								<div>
									<StatusLabel small type={item.service.badge}>{item.service.label}</StatusLabel>
									&nbsp;{item?.package && <StatusLabel small type={item.service.badge}>{item?.package}</StatusLabel>}
								</div>
								<b>Phí gia hạn: {numberFormat(item?.price)}</b>
							</>
						}
					</>
				}

			</>
		)},
		{title: 'Phân công', dataIndex: 'user', key: "user", width: '200px', render: (_, item) => (
			<>
				{item.user?.id && <p>{`${item.user?.firstname} ${item.user?.lastname}`}</p>}
				{item.userShare?.id && <p>{`${item.userShare?.firstname} ${item.userShare?.lastname}`}</p>}
			</>
		)},
		{title: 'Phí gia hạn', dataIndex: 'price', key: "price", width: '150px', render: (_, item) => (
			<b>{numberFormat(item?.price)}</b>
		)},
		{title: 'Ngày', dataIndex: 'timeMobile', key: "timeMobile", width: '150px', render: (_, item) => (
			<>
				<p>ĐK: {renderDate(item?.register)}</p>
				<p>HH: {renderDate(item?.expired)}</p>
			</>
		)},
		{title: 'Chăm sóc', dataIndex: 'supportMobile', key: "supportMobile", width: '150px', render: (_, item) => (
			<>
				<p className="mb-1">Email: {renderEmail(item?.extend)}</p>
				<p className="mb-1">Zalo: {renderZalo(item?.extend)}</p>
				<p className="mb-1">Gọi điện: {renderZalo(item?.status)}</p>
			</>
		)},
		{title: 'Dịch vụ', dataIndex: 'service', key: 'service', width: '150px', render:(_, item) => (
			<div>
				<StatusLabel small type={item.service.badge}>{item.service.label}</StatusLabel>
				&nbsp;
				{
					(item?.package) && <StatusLabel small type={item.service.badge}>{item?.package}</StatusLabel>
				}
			</div>
		)},
		{title: 'Ngày ký', dataIndex: 'register', key: "register", render: (_, item) => (renderDate(item?.register)) },
		{title: 'Ngày hết hạn', dataIndex: 'expired', key: "expired", render: (_, item) => (renderDate(item?.expired)) },
		{title: 'Trạng thái', dataIndex: 'status', key: "status", render: (_, item) => <StatusLabel small type={item.status.badge}>{item.status.label}</StatusLabel> },
		{title: 'Ip', dataIndex: 'ip', key: "ip", render: (_, item) =>  (<>
			<a href={"http://"+item?.hostIp+":2222"} target="_blank">{item?.hostIp}</a>
		</>)},
		{title: 'Email', dataIndex: 'email', key: "email", render: (_, item) => (renderEmail(item?.extend)) },
		{title: 'Zalo', dataIndex: 'zalo', key: "zalo", render: (_, item) => (renderZalo(item?.extend)) },
		{title: 'Gọi điện', dataIndex: 'call', key: "call", render: (_, item) => (renderCall(item?.supportId, item?.supportTime)) },
		{title: '#', dataIndex: 'action', key: "action", width: '180px', render: (_, item) => (
			<ServiceAction
				key={item.id}
				item={item}
				openModal={openModal}
				setItemEdit={setItemEdit}
				can={can}
				serviceUseAllow={serviceUseAllow}
				serviceUseCancel={serviceUseCancel}
			/>
		)},
	];

	if(isMobile) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'user'
				&& currentValue.key !== 'service'
				&& currentValue.key !== 'register'
				&& currentValue.key !== 'expired'
				&& currentValue.key !== 'email'
				&& currentValue.key !== 'zalo'
				&& currentValue.key !== 'call'
				&& currentValue.key !== 'price'
			)
		})
	}
	else {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'supportMobile' && currentValue.key !== 'timeMobile')
		})
	}

	if(!useCan('serviceExtend')) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'email'
				&& currentValue.key !== 'zalo'
				&& currentValue.key !== 'call'
				&& currentValue.key !== 'register'
				&& currentValue.key !== 'expired'
			)
		})
	}

	if(!useCan('serviceExtendSr')) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'price')
		})
	}

	if(!useCan('serviceHostEdit')) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'ip')
		})
	}

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} rowKey="id" dataSource={items} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default memo(ServiceTable);